<template>
  <div v-if="$product.availableAttributes.length" class="has-margin-top-75">
    <b-field
      v-for="category in $product.availableAttributes"
      :key="`attr_category_${category.id}`"
      :label="category.name + (category.required ? ' *' : '')"
      :type="{ 'is-danger': hasError(`attr_category_${category.id}`) }"
      :message="{
        [getFirstError(`attr_category_${category.id}`)]: hasError(
          `attr_category_${category.id}`
        )
      }"
    >
      <ValidationProvider
        :vid="`attr_category_${category.id}`"
        :rules="`${category.required ? 'required' : ''}`"
        :custom-messages="{
          required: $t('_.this_is_a_required_configuration')
        }"
        slim
      >
        <selector
          :key="`attr_category_${category.id}`"
          v-model="$product.selectedAttributes[category.id]"
          :native-value-path="`id`"
          :items="category.attributes"
          :multiselect="category.attributes.length === 1 || category.multiple"
          :name="`attr_category_${category.id}`"
          :type="hasError(`attr_category_${category.id}`) ? 'is-danger' : null"
          :disabled="disabled"
        >
          <template v-slot:left-label="{ item }">
            {{ item.name }}
          </template>
        </selector>
      </ValidationProvider>
    </b-field>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import HasValidation from "@/mixins/HasValidation";
import type { IProductConfigProviderData } from "@/models/providers/products";
import type { PropType } from "vue/types/v3-component-props";

export default defineComponent({
  name: "ProductAttributes",
  mixins: [HasValidation],
  inject: {
    $productConfigData: {
      from: "productConfigProviderData",
      type: Function as PropType<IProductConfigProviderData>
    }
  },
  props: {
    disabled: { type: Boolean, default: false }
  },
  computed: {
    $product() {
      return this.$productConfigData();
    }
  }
});
</script>
